import { Card, PageContainer, Skeleton } from '@/components/ui'

export default function OrdersLoading() {
  return (
    <PageContainer top="header-gap" bottom="chrome" className="flex flex-col gap-4" aria-busy>
      {[1, 2, 3].map((index) => (
        <Card key={index} padding="md" className="flex flex-col gap-4">
          <div className="flex w-full items-start justify-between gap-3">
            <div className="flex flex-col gap-2">
              <Skeleton className="h-6 w-32" />
              <Skeleton className="w-40" />
            </div>
            <Skeleton className="w-16" />
          </div>
          <Skeleton shape="pill" className="h-6 w-24" />
          {[1, 2].map((itemIndex) => (
            <div key={itemIndex} className="flex flex-col gap-2">
              <Skeleton className="h-5 w-48" />
              <Skeleton className="h-3 w-36" />
              <Skeleton className="h-3 w-28" />
            </div>
          ))}
          <Skeleton className="h-6 w-full" />
        </Card>
      ))}
    </PageContainer>
  )
}
